module.exports = __webpack_public_path__ + "img/appsflyer.png";